import { LoggerService as lgg } from "vue-components-library";

import config from "@/App/config";
import { Store } from "@/App/store";
import { HttpEngine } from "@/App/services";
import { USER_SESSION_EXPIRED } from "@/Login/store/Messages";

const LOG_TAG = "[HTTP CLIENT]";

export interface PostRequest {
  path: string;
  data?: any;
  rewriteBaseUrlWith?: string;
  errorHandler?: any;
}

export const post = ({
  path,
  data = {},
  rewriteBaseUrlWith = undefined,
  errorHandler = handleResponseError
}: PostRequest): Promise<any> => {
  return HttpEngine({ url: path, baseURL: rewriteBaseUrlWith, method: "POST", data }).catch(errorHandler);
};

export interface BaseRequest {
  path: string;
  rewriteBaseUrlWith?: string;
  errorHandler?: any;
}

export const get = ({
  path,
  rewriteBaseUrlWith = undefined,
  errorHandler = handleResponseError
}: BaseRequest): Promise<any> => {
  return HttpEngine({ baseURL: rewriteBaseUrlWith, url: path }).catch(errorHandler);
};
export const downloadFile = ({
  path,
  rewriteBaseUrlWith = undefined,
  errorHandler = handleResponseError
}: BaseRequest): Promise<any> => {
  return HttpEngine({
    baseURL: rewriteBaseUrlWith || config.API_URL,
    url: path,
    method: "GET",
    responseType: "blob"
  }).catch(errorHandler);
};

export const put = (path: string, request: any): Promise<any> => {
  return HttpEngine.put(path, request).catch(handleResponseError);
};

export const del = (path: string): Promise<any> => {
  return HttpEngine.delete(path).catch(handleResponseError);
};

function handleResponseError(error: any) {
  const { status } = error.response;

  lgg.error(`${LOG_TAG} Error:`, error);

  Store.dispatch("Global/doneLoading");

  const errorHandlers: any = {
    401: () => {
      if (Store.getters["Login/authToken"]) {
        Store.dispatch("Login/logout");
        Store.dispatch("Login/setGeneralError", USER_SESSION_EXPIRED);
      }
    },
    default: () => {
      Store.dispatch("Error/setError", "Error processing request.");
      throw error;
    }
  };
  const handler = errorHandlers[status] || errorHandlers["default"];
  handler();
}

export default {
  get,
  post,
  put,
  delete: del,
  downloadFile
};
